<header id="page-topbar">
  <div class="navbar-header">
    <div class="d-flex">
      <!-- LOGO -->
      <div class="navbar-brand-box">
        <a routerLink="/" class="logo logo-dark">
          <span class="logo-sm">
            <img src="assets/images/logo.svg" alt="" height="22">
          </span>
          <span class="logo-lg">
            <img src="assets/images/logo-dark.png" alt="" height="17">
          </span>
        </a>

        <a routerLink="/" class="logo logo-light">
          <span class="logo-sm">
            <img src="assets/images/logo-light.svg" alt="" height="22">
          </span>
          <span class="logo-lg">
            <img src="assets/images/logo-light.png" alt="" height="19">
          </span>
        </a>
      </div>

      <button type="button" class="btn btn-sm px-3 font-size-16 header-item" id="vertical-menu-btn"
        (click)="toggleMobileMenu($event)">
        <i class="fa fa-fw fa-bars"></i>
      </button>

    </div>

    <div class="d-flex">

      <div class="dropdown d-inline-block d-lg-none ms-2" ngbDropdown>
        <button type="button" class="btn header-item noti-icon" id="page-header-search-dropdown" data-toggle="dropdown"
          aria-haspopup="true" ngbDropdownToggle aria-expanded="false">
          <i class="mdi mdi-magnify"></i>
        </button>
        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0" ngbDropdownMenu
          aria-labelledby="page-header-search-dropdown">

          <form class="p-3">
            <div class="m-0">
              <div class="input-group">
                <input type="text" class="form-control" placeholder="Search ..." aria-label="Recipient's username">
                <div class="input-group-append">
                  <button class="btn btn-primary" type="submit"><i class="mdi mdi-magnify"></i></button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div class="dropdown d-none d-lg-inline-block ms-1">
        <button type="button" class="btn header-item noti-icon" data-toggle="fullscreen" (click)="fullscreen()">
          <i class="bx bx-fullscreen"></i>
        </button>
      </div>

      <div class="dropdown d-inline-block" ngbDropdown *ngIf="vnotifica > 0"> 
        <button type="button" class="btn header-item noti-icon" id="page-header-notifications-dropdown"
          ngbDropdownToggle>
          <i class="bx bx-bell bx-tada"></i>
          <span class="badge bg-danger rounded-pill">{{vnotifica}}</span>
        </button>
        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
          aria-labelledby="page-header-notifications-dropdown" ngbDropdownMenu>
          <div class="p-3">
            <div class="row align-items-center">
              <div class="col">
                <h6 class="m-0">{{ 'HEADER.NOTIFICATIONS.TITLE' | translate}} </h6>
              </div>
            </div>
          </div>
          <ngx-simplebar style="position: relative; height: 230px;">
            <a href="javascript: void(0);" class="text-reset notification-item" *ngIf="vnotifica==1">
              <div class="media">
                <div class="avatar-xs me-3">
                  <span class="avatar-title bg-primary rounded-circle font-size-16">
                    <i class="bx bx-cart"></i>
                  </span>
                </div>
                <div class="media-body">
                  <h6 class="mt-0 mb-1">Hay productos con inventario al limite...</h6>
                  <div class="font-size-12 text-muted">
                    <p class="mb-1 txnoti">Cuando se alcanza el stock mínimo de un producto, debería realizar una nueva compra!</p>
                    <p class="mb-0"><i class="mdi mdi-check-all mrgicon"></i>
                      <a href="javascript: void(0);" (click)="largeModalProdMin(modalMinProduct)">>>Revisar Inventario<<</a>
                    </p>
                  </div>
                </div>
              </div>
            </a>
            <!--<a href="javascript: void(0);" class="text-reset notification-item">
              <div class="media">
                <img src="assets/images/users/avatar-3.jpg" class="me-3 rounded-circle avatar-xs" alt="user-pic">
                <div class="media-body">
                  <h6 class="mt-0 mb-1">{{ 'HEADER.NOTIFICATIONS.SECOND.TITLE' | translate}}</h6>
                  <div class="font-size-12 text-muted">
                    <p class="mb-1">{{ 'HEADER.NOTIFICATIONS.SECOND.TEXT' | translate}}</p>
                    <p class="mb-0"><i class="mdi mdi-clock-outline"></i>{{ 'HEADER.NOTIFICATIONS.SECOND.TIME' |
                      translate}}</p>
                  </div>
                </div>
              </div>
            </a>
            <a href="javascript: void(0);" class="text-reset notification-item">
              <div class="media">
                <div class="avatar-xs me-3">
                  <span class="avatar-title bg-success rounded-circle font-size-16">
                    <i class="bx bx-badge-check"></i>
                  </span>
                </div>
                <div class="media-body">
                  <h6 class="mt-0 mb-1">{{ 'HEADER.NOTIFICATIONS.THIRD.TITLE' | translate}}</h6>
                  <div class="font-size-12 text-muted">
                    <p class="mb-1">{{ 'HEADER.NOTIFICATIONS.THIRD.TEXT' | translate}}</p>
                    <p class="mb-0"><i class="mdi mdi-clock-outline"></i>{{ 'HEADER.NOTIFICATIONS.THIRD.TIME' |
                      translate}}</p>
                  </div>
                </div>
              </div>
            </a>
            <a href="javascript: void(0);" class="text-reset notification-item">
              <div class="media">
                <img src="assets/images/users/avatar-4.jpg" class="me-3 rounded-circle avatar-xs" alt="user-pic">
                <div class="media-body">
                  <h6 class="mt-0 mb-1">{{ 'HEADER.NOTIFICATIONS.FOUR.TITLE' | translate}}</h6>
                  <div class="font-size-12 text-muted">
                    <p class="mb-1">{{ 'HEADER.NOTIFICATIONS.FOUR.TEXT' | translate}}</p>
                    <p class="mb-0"><i class="mdi mdi-clock-outline"></i>{{ 'HEADER.NOTIFICATIONS.FOUR.TIME' |
                      translate}}</p>
                  </div>
                </div>
              </div>
            </a>-->
          </ngx-simplebar>
          <!--<div class="p-2 border-top d-grid">
            <a class="btn btn-sm btn-link font-size-14 text-center" href="javascript:void(0)">
              <i class="mdi mdi-arrow-right-circle me-1"></i> <span key="t-view-more">{{
                'HEADER.NOTIFICATIONS.LOAD_MORE' | translate}}</span>
            </a>
          </div>-->
        </div>
      </div>

      <div class="dropdown d-inline-block" ngbDropdown>
        <button type="button" class="btn header-item" ngbDropdownToggle id="page-header-user-dropdown">
          <img class="rounded-circle header-profile-user" [src]="nimage" alt="Header Avatar">
          <span class="d-none d-xl-inline-block ms-1">{{nuser}}</span>
          <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
        </button>
        <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
          <!-- item-->
          <a class="dropdown-item" routerLink="/user-profile"><i class="bx bx-user font-size-16 align-middle me-1"></i>
            {{ 'HEADER.LOGIN.PROFILE' | translate}}</a>
          <div class="dropdown-divider"></div>
          <a class="dropdown-item text-danger" href="javascript: void(0);" (click)="logout()"><i
              class="bx bx-power-off font-size-16 align-middle me-1 text-danger"></i>
            {{ 'HEADER.LOGIN.LOGOUT' | translate}}</a>
        </div>
      </div>

      <div class="dropdown d-inline-block">
        <button type="button" class="btn header-item noti-icon right-bar-toggle" (click)="toggleRightSidebar()">
          <i class="bx bx-cog bx-spin"></i>
        </button>
      </div>

    </div>
  </div>
</header>
<!-- Modal de detalle de productos con stock minimo alcanzado-->
<ng-template #modalMinProduct let-modal>
  <div class="modal-header btn-info">
    <h5 class="modal-title mt-0"><b class="txcenter"><i class="fas fa-angle-double-down"></i> ::. Productos con inventario mínimo alcanzado.:: <i class="fas fa-angle-double-down"></i></b></h5>
    <button type="button" class="btn-close" (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mrgbott">
              <div class="col-md-3 btnrg">
                  <button class="btn btn-success" (click)="exportToExcel()"><i class="mdi mdi-file-excel"></i> Exportar a Excel</button>
              </div>
              <div class="col-md-9"></div>
          </div>
            <div class="row mb-md-2 mrgtop">
              <div class="col-sm-12 col-md-6">
                <div class="dataTables_length" id="tickets-table_length">
                  <label
                    class="d-inline-flex align-items-center">Mostrando
                    <select name="tickets-table_length" aria-controls="tickets-table" name="pageSize"
                      [(ngModel)]="service.pageSize" class="form-control form-control-sm mx-2">
                      <option [ngValue]="10">10</option>
                      <option [ngValue]="25">25</option>
                      <option [ngValue]="50">50</option>
                      <option [ngValue]="100">100</option>
                    </select> Entradas</label></div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end"><label
                    class="d-inline-flex align-items-center">Buscar:
                    <input type="text" name="searchTerm2" class="form-control form-control-sm ms-2"
                      aria-controls="tickets-table" [(ngModel)]="service.searchTerm"></label></div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive">
              <table id="basic-datatable" class="table table-bordered dt-responsive nowrap datatables no-footer dtr-inline">
                <thead>
                  <tr class="btn-dark fnwth">
                      <th class="txcenter" sortable="id" (sort)="onSort($event)">No.</th>
                      <th class="txcenter" sortable="Codigo" (sort)="onSort($event)">Codigo</th>
                      <th class="txcenter" sortable="Nombre" (sort)="onSort($event)">Nombre</th>
                      <th class="txcenter" sortable="Cantidad_Minima" (sort)="onSort($event)">Cant. Min.</th>
                      <th class="txcenter" sortable="Stock" (sort)="onSort($event)">Stock</th>
                      <th class="txcenter" sortable="Categoria" (sort)="onSort($event)">Categoria</th>
                  </tr>
                </thead>
                <tbody *ngFor="let table of tables$ | async;let i=index">
                  <tr class="fnwtr">
                      <td class="txcenter">
                          <ngb-highlight [result]="i+1"></ngb-highlight>
                      </td>
                      <td class="txcenter">
                          <ngb-highlight [result]="table.Codigo" [term]="service.searchTerm"></ngb-highlight>
                      </td>
                      <td class="txcenter">
                          <ngb-highlight [result]="table.Nombre" [term]="service.searchTerm"></ngb-highlight>
                      </td>
                      <td class="txcenter">
                          <ngb-highlight [result]="table.Cantidad_Minima" [term]="service.searchTerm"></ngb-highlight>
                      </td>
                      <td class="txcenter">
                          <ngb-highlight [result]="table.Stock" [term]="service.searchTerm"></ngb-highlight>
                      </td>
                      <td class="txcenter">
                        <ngb-highlight [result]="table.Categoria" [term]="service.searchTerm"></ngb-highlight>
                      </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- End table -->
            <div class="row justify-content-md-between align-items-md-center mt-2">
              <div class="col-sm-12 col-md-5">
                <div class="dataTables_info mb-2" id="tickets-table_info" role="status" aria-live="polite">Mostrando
                  {{service.startIndex}} al
                  {{service.endIndex}} de {{service.totalRecords}}
                  entradas
                </div>
              </div>
              <!-- Pagination -->
              <div class="col-sm-12 col-md-5">
                <div class="text-md-right float-md-end pagination-rounded">
                  <ngb-pagination [collectionSize]="total$ | async" [(page)]="service.page" [pageSize]="service.pageSize">
                  </ngb-pagination>
                </div>
              </div>
              <!-- End Pagination -->
            </div>
          </div>
        </div>
      </div>
  </div>
  </div>
</ng-template>